module.exports = __webpack_public_path__ + "i18n/en_234b28e6f0f748b4e43b77e54d48583e.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_en.properties
// module id = A5Ct
// module chunks = 51